export default {
  VIEW_HEADER_DROPDOWN: 'VIEW_HEADER_DROPDOWN',
  VIEW_HOME_PAGE: 'VIEW_HOME_PAGE',
  VIEW_HOME_PAGE_OTHER: 'VIEW_HOME_PAGE_OTHER',
  VIEW_HOME_PAGE_COMMERCIAL: 'VIEW_HOME_PAGE_COMMERCIAL',
  VIEW_ACCOUNT_PAGE: 'VIEW_ACCOUNT_PAGE',
  VIEW_DOCTOR_PAGE: 'VIEW_DOCTOR_PAGE',
  VIEW_DIAGNOSTIC_UNITS_PAGE: 'VIEW_DIAGNOSTIC_UNITS_PAGE',
  VIEW_B2B_PAGE: 'VIEW_B2B_PAGE',
  VIEW_QUESTIONS_PAGE: 'VIEW_QUESTIONS_PAGE',
  VIEW_CONCENTS_PAGE: 'VIEW_CONCENTS_PAGE',
  VIEW_APPOINTMENTS_PAGE: 'VIEW_APPOINTMENTS_PAGE',
  VIEW_REPORTS_PAGE: 'VIEW_REPORTS_PAGE',
  VIEW_SERIAL_MENU: 'VIEW_SERIAL_MENU',
  VIEW_SERIAL_NUMBERS_PAGE: 'VIEW_SERIAL_NUMBERS_PAGE',
  VIEW_TRAITS_PAGE: 'VIEW_TRAITS_PAGE',
  VIEW_ASSOCIATION_REPORTS_PAGE: 'VIEW_ASSOCIATION_REPORTS_PAGE',
  VIEW_UPGRADED_KITS_PAGE: 'VIEW_UPGRADED_KITS_PAGE',
  VIEW_SNPS_PAGE: 'VIEW_SNPS_PAGE',
  VIEW_USERS_PAGE: 'VIEW_USERS_PAGE',
  VIEW_THEMATIC_PACKAGE_PAGE: 'VIEW_THEMATIC_PACKAGE_PAGE',
  VIEW_DIAGNOSTIC_PACKAGE_PAGE: 'VIEW_DIAGNOSTIC_PACKAGE_PAGE',
  CREATE_THEMATIC_PACKAGE: 'CREATE_THEMATIC_PACKAGE',
  EDIT_THEMATIC_PACKAGE: 'EDIT_THEMATIC_PACKAGE',
  DELETE_THEMATIC_PACKAGE: 'DELETE_THEMATIC_PACKAGE',
  VIEW_THEMATIC_PACKAGE: 'VIEW_THEMATIC_PACKAGE',
  VIEW_MISCELLANEOUS: 'VIEW_MISCELLANEOUS',
  SHOW_TRAITS: 'SHOW_TRAITS',
  RESET_THEMATIC_PACKAGE: 'RESET_THEMATIC_PACKAGE',
  SAVE_THEMATIC_PACKAGE: 'SAVE_THEMATIC_PACKAGE',
  EDIT_PRODUCT_CODE: 'EDIT_PRODUCT_CODE',
  EDIT_DESCRIPTION: 'EDIT_DESCRIPTION',
  EDIT_NAME: 'EDIT_NAME',
  EDIT_POPULATION_GROUP: 'EDIT_POPULATION_GROUP',
  EDIT_REPORT_FIELD: 'EDIT_REPORT_FIELD',
  EDIT_CATEGORY: 'EDIT_CATEGORY',
  EDIT_THEMATIC_GROUP: 'EDIT_THEMATIC_GROUP',
  EDIT_DIAGNOSTIC_PACKAGE_FIELD: 'EDIT_DIAGNOSTIC_PACKAGE_FIELD',
  EDIT_APPROVAL_STATUS: 'EDIT_APPROVAL_STATUS',
  EDIT_DEVICES: 'EDIT_DEVICES',
  EDIT_MEASUREMENT_UNIT: 'EDIT_MEASUREMENT_UNIT',
  EDIT_TAX: 'EDIT_TAX',
  EDIT_ACCOUNTING_CATEGORY: 'EDIT_ACCOUNTING_CATEGORY',
  EDIT_BARCODE: 'EDIT_BARCODE',
  EDIT_BUSINESS_UNIT: 'EDIT_BUSINESS_UNIT',
  EDIT_WHOLESALE_PRICE: 'EDIT_WHOLESALE_PRICE',
  EDIT_RETAIL_PRICE: 'EDIT_RETAIL_PRICE',
  RUN_EDAG: 'RUN_EDAG',
  ADD_TRAIT_TO_THEMATIC_PACKAGE: 'ADD_TRAIT_TO_THEMATIC_PACKAGE',
  DELETE_TRAIT_FROM_THEMATIC_PACKAGE: 'DELETE_TRAIT_FROM_THEMATIC_PACKAGE',
  SHOW_TRAIT_SNPS: 'SHOW_TRAIT_SNPS',
  ADD_SNP_TO_TRAIT: 'ADD_SNP_TO_TRAIT',
  DELETE_SNP_FROM_TRAIT: 'DELETE_SNP_FROM_TRAIT',
  CREATE_TRAIT: 'CREATE_TRAIT',
  EDIT_TRAIT: 'EDIT_TRAIT',
  DELETE_TRAIT: 'DELETE_TRAIT',
  VIEW_TRAIT: 'VIEW_TRAIT',
  CREATE_SNP: 'CREATE_SNP',
  EDIT_SNP: 'EDIT_SNP',
  DELETE_SNP: 'DELETE_SNP',
  VIEW_SNP: 'VIEW_SNP',
  CREATE_DIAGNOSTIC_PACKAGE: 'CREATE_DIAGNOSTIC_PACKAGE',
  EDIT_DIAGNOSTIC_PACKAGE: 'EDIT_DIAGNOSTIC_PACKAGE',
  DELETE_DIAGNOSTIC_PACKAGE: 'DELETE_DIAGNOSTIC_PACKAGE',
  VIEW_DIAGNOSTIC_PACKAGE: 'VIEW_DIAGNOSTIC_PACKAGE',
  CREATE_DOCTOR: 'CREATE_DOCTOR',
  EDIT_DOCTOR: 'EDIT_DOCTOR',
  DELETE_DOCTOR: 'DELETE_DOCTOR',
  VIEW_DOCTOR: 'VIEW_DOCTOR',
  CREATE_DIAGNOSTIC_UNIT: 'CREATE_DIAGNOSTIC_UNIT',
  EDIT_DIAGNOSTIC_UNIT: 'EDIT_DIAGNOSTIC_UNIT',
  DELETE_DIAGNOSTIC_UNIT: 'DELETE_DIAGNOSTIC_UNIT',
  VIEW_DIAGNOSTIC_UNIT: 'VIEW_DIAGNOSTIC_UNIT',
  CREATE_B2B: 'CREATE_B2B',
  EDIT_B2B: 'EDIT_B2B',
  DELETE_B2B: 'DELETE_B2B',
  VIEW_B2B: 'VIEW_B2B',
  CREATE_REPORT: 'CREATE_REPORT',
  EDIT_REPORT: 'EDIT_REPORT',
  DELETE_REPORT: 'DELETE_REPORT',
  VIEW_REPORT: 'VIEW_REPORT',
  CREATE_QUESTIONNAIRE: 'CREATE_QUESTIONNAIRE',
  EDIT_QUESTIONNAIRE: 'EDIT_QUESTIONNAIRE',
  DELETE_QUESTIONNAIRE: 'DELETE_QUESTIONNAIRE',
  VIEW_QUESTIONNAIRE: 'VIEW_QUESTIONNAIRE',
  EDIT_THEMATIC_PACKAGE_STATUS_: 'd',
  GENERAL_REPORT_FINALIZE_VIEW: 'GENERAL_REPORT_FINALIZE_VIEW',
  THIRD_PARTY_REPORT_FINALIZE_VIEW: 'THIRD_PARTY_REPORT_FINALIZE_VIEW',
  ANALYTICS_REPORT_FINALIZE_VIEW: 'ANALYTICS_REPORT_FINALIZE_VIEW',
  GENERAL_REPORT_FINALIZE_EDIT: 'GENERAL_REPORT_FINALIZE_EDIT',
  THIRD_PARTY_REPORT_FINALIZE_EDIT: 'THIRD_PARTY_REPORT_FINALIZE_EDIT',
  ANALYTICS_REPORT_FINALIZE_EDIT: 'ANALYTICS_REPORT_FINALIZE_EDIT',
  VIEW_CARDIO_REPORTS_PAGE: 'VIEW_CARDIO_REPORTS_PAGE',
  VIEW_BIO_AGE_REPORTS_PAGE: 'VIEW_BIO_AGE_REPORTS_PAGE',

  VIEW_DOCTOR_KITS_PAGE: 'VIEW_DOCTOR_KITS_PAGE',
  VIEW_CORPORATE_KITS_PAGE: 'VIEW_CORPORATE_KITS_PAGE',
  VIEW_KITS_PAGE: 'VIEW_KITS_PAGE',
  VIEW_EXTRA_FIELDS_OTHER_REPORTS_PAGE: 'VIEW_EXTRA_FIELDS_OTHER_REPORTS_PAGE',

  VIEW_EMAIL_TEMPLATES_PAGE: 'VIEW_EMAIL_TEMPLATES_PAGE',
  VIEW_TRANSLATIONS_PAGE: 'VIEW_TRANSLATIONS_PAGE',
  VIEW_NG_REPORTS_PAGE: 'VIEW_NG_REPORTS_PAGE',
  VIEW_PGX_REPORTS_PAGE: 'VIEW_PGX_REPORTS_PAGE',
  VIEW_3IN1_REPORTS_PAGE: 'VIEW_3IN1_REPORTS_PAGE',
  VIEW_NUTRITION_REPORTS_PAGE: 'VIEW_NUTRITION_REPORTS_PAGE',
  VIEW_VITAMINS_REPORTS_PAGE: 'VIEW_VITAMINS_REPORTS_PAGE',
  VIEW_PROMO_CODES_PAGE: 'VIEW_PROMO_CODES_PAGE',

  VIEW_BUSINESS_MANAGEMENT_PAGE: 'VIEW_BUSINESS_MANAGEMENT_PAGE',

  VIEW_MANAGEMENT_MENU: 'VIEW_MANAGEMENT_MENU',
  VIEW_REPORTS_MENU: 'VIEW_REPORTS_MENU',
  VIEW_MISCELLANEOUS_MENU: 'VIEW_MISCELLANEOUS_MENU',
  VIEW_TOOLS_MENU: 'VIEW_TOOLS_MENU',
  VIEW_REGISTRATION_MENU: 'VIEW_REGISTRATION_MENU',
  VIEW_LAB_MENU: 'VIEW_LAB_MENU',
  VIEW_LAB_FILES_PAGE: 'VIEW_LAB_FILES_PAGE',
  VIEW_LAB_SAMPLES_PAGE: 'VIEW_LAB_SAMPLES_PAGE',
  VIEW_MANAGER_MENU: 'VIEW_MANAGER_MENU',
};
